import React from 'react';
import './ChatSummaryPanel.css';

export default function ChatSummaryPanel({ overallSummary }) {
  const text = String(overallSummary || '').trim();
  if (!text) return null;

  const paragraphs = text.split(/\n{2,}/).map((part) => part.trim()).filter(Boolean);

  return (
    <div className="chat-summary-panel">
      {paragraphs.map((paragraph) => (
        <p key={paragraph}>{paragraph}</p>
      ))}
    </div>
  );
}
